import { Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { oneLine } from 'common-tags';

import Close from '@/icons/light/x.svg';

import type { FunctionComponent } from 'react';
import type { TypeModalProps } from './types';

export const Modal: FunctionComponent<TypeModalProps> = ({
  children,
  isOpen = true,
  closeModal,
  className = '',
  classModal = '',
  contentClassName = '',
  title,
  unmount = false,
}: TypeModalProps) => (
  <Transition appear show={isOpen} as={Fragment} unmount={unmount}>
    <Dialog
      as="div"
      className="relative z-50"
      onClose={closeModal}
      unmount={unmount}
    >
      <Transition.Child
        unmount={unmount}
        as={Fragment}
        enter="ease-out duration-300"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="ease-in duration-200"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      >
        <div className="bg-neutrals-900/30 fixed inset-0" />
      </Transition.Child>

      <div className="fixed inset-0 overflow-y-auto">
        <div
          className={`flex min-h-full w-full items-center justify-center p-4 ${classModal}`}
        >
          <Transition.Child
            unmount={unmount}
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <Dialog.Panel
              className={oneLine`rounded-t-custom md:rounded-custom bg-neutrals-0 xs:px-4 xs:pt-6 fixed bottom-0 flex max-h-[calc(100vh-32px)] w-full transform flex-col px-2 pt-2 transition-all md:relative md:px-10 md:pt-6 lg:max-h-none ${className} `}
            >
              <div
                className={oneLine`mb-5 flex gap-6 text-left ${title ? 'justify-between' : 'justify-end'} `}
              >
                <Dialog.Title
                  as="h3"
                  className="text-headline text-headline-h4 line-clamp-1"
                >
                  {title}
                </Dialog.Title>

                <button
                  type="button"
                  onClick={closeModal}
                  className="focus-visible:ring-0 focus-visible:ring-offset-0 focus-visible:outline-hidden"
                >
                  <Close width={24} height={24} />
                </button>
              </div>

              <div
                className={oneLine`xs:pb-4 overflow-y-auto pb-2 text-sm text-gray-500 md:pb-6 lg:overflow-y-visible ${contentClassName}`}
              >
                {children}
              </div>
            </Dialog.Panel>
          </Transition.Child>
        </div>
      </div>
    </Dialog>
  </Transition>
);

Modal.displayName = 'Modal';
